import React from "react"
import { Grid, Row, Col, Image } from "react-bootstrap"
import Sidebar from "../components/Sidebar.js"
import aboutPhoto from "../assets/aboutphoto.jpg"
import { Seo } from "../components/Seo.js"

const About = () => (
  <Grid fluid>
    <Seo title="About"></Seo>
    <Row>
      <Col md = { 1 }>
        <Sidebar />
      </Col>
      <Col md = { 11 } className = { "about" }>
        <Image responsive className = { "about-photo" } src = { aboutPhoto }/>
        <div className = { "bio" }>
          <p>Giacomo Bruno is an Italian photographer born in 1991 based in Reggio Emilia, Italy.</p>
          <p>He produces personal projects on life, craft and agriculture, providing insights into how rural areas develop and survive across the globe.</p>
          <p>He started as assistant photographer straight after high school, working in two advertising and product photography studios until 2013, when he decided to take his own path following his passion for traveling and his true vocation:  portrait photography and reportage.</p>
          <p>He worked on numerous reportages in Latin America, China, Japan, Sri Lanka, South Africa and his projects have been published in leading international magazines, such as Corriere della Sera and Le Monde.fr, but also editorials and magazines like Perimetro, C41 Magazine, Mia Le Journal, SlackTide Mag, Zeitjung, Gräfe and Unzer, The post internazionale, Erodoto108 and others.</p>
          <p>He has collaborated with important international advertising agencies, such as McCann Worldgroup, Merchant Cantos, Brunswick Group, Esse House and K48 and important local companies such as VENTIE30 and The Block MultiVisual.</p>
        </div>
      </Col>
    </Row>
  </Grid>
)

export default About



// WEBPACK FOOTER //
// ./src/containers/About.js